export default "__VITE_ASSET__DOrgZft3__"